import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./Notificatio.module.css";
import Lottie from "lottie-react";
import Thumsup from "./Thumsup.json";
import companyStore from "../../../Store/Store";

const Notificatio = ({
  isVisible,
  onClose,
  isAdmin,
  TopUpNoti,
  isViewAdmin,
  isUser,
  className = "",
}) => {
  const navigate = useNavigate();
  console.log("NOtificationisAdmin", isAdmin);
  console.log("NOtificationTopUpNoti", TopUpNoti);
  console.log("NOtificationisVisible", isVisible);
  console.log("NOtificationisUser-------->", isUser);
  const [NotificationText, setNotificationText] = useState("");
  const onXCircleIconClick = useCallback(() => {
    navigate("/content/users");
  }, [navigate]);
  useEffect(() => {
    if (TopUpNoti) {
      //Topup Notification
      setNotificationText("Top-up added successfully");
      return;
    }

    if (companyStore.userType == "AxisUser") {
      //Axis FLow
      if (isAdmin) {
        //only Admin
        setNotificationText("New Admin has been added");
        return;
      } else if (isViewAdmin && isUser) {
        // Admin and User
        setNotificationText("Dashboard Viewer & CUPI App user has been added");
        return;
      } else if (isViewAdmin) {
        // only ViewAdmin
        setNotificationText("Dashboard Viewer has been added");
        return;
      } else if (isUser) {
        // only user
        setNotificationText("New user has been added.");
        return;
      } else {
        //Unknown Request
        setNotificationText("New user has been added.");
      }
    }

    if (companyStore.userType == "PineLabUser") {
      //Pinelabs Flow
      if (isAdmin && isUser) {
        //Admin + User
        setNotificationText(
          "Admin Added Succesfully & KYC Link sent to the User Email & Phone.",
        );
        return;
      } else if (isAdmin) {
        //only Admin
        setNotificationText("Admin added successfully");
        return;
      } else if (isViewAdmin && isUser) {
        // Admin and User
        setNotificationText(
          `Dashboard Viewer Added Succesfully & KYC Link sent to the User Email & Phone.`,
        );
        return;
      } else if (isViewAdmin) {
        // only ViewAdmin
        setNotificationText("Dashboard Viewer Added Succesfully");
        return;
      } else if (isUser) {
        // only user
        setNotificationText("KYC Link sent to the User Email & Phone.");
        return;
      } else {
        if (companyStore.initiateKYC == "AddedToUserList") {
          setNotificationText("Top-up added successfully");
        } else if (companyStore.initiateKYC == "AddedToPendingList") {
          setNotificationText("KYC done! User addition is pending.");
        } else {
          setNotificationText("KYC Link sent to the User Email & Phone.");
        }
      }
    }
  }, []);
  if (!isVisible) return null;
  return (
    <div
      className={[styles.frameParent, className].join(" ")}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div className={styles.containerNotifi}>
        <div
          className={
            !TopUpNoti ? styles.xCircleWrapper : styles.xCircleWrapper2
          }
        >
          {TopUpNoti && <div>Add Top-up</div>}
          <img
            className={styles.xCircleIcon}
            alt=""
            src="/xcircle1.svg"
            onClick={onClose}
          />
        </div>
        <div className={styles.httpslottiefilescomanimatParent}>
          <Lottie
            className={styles.httpslottiefilescomanimatIcon}
            animationData={Thumsup}
            loop={true}
          />
          <div className={styles.userAddedSuccessfully}>{NotificationText}</div>
        </div>
        {companyStore.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
      </div>
    </div>
  );
};

Notificatio.propTypes = {
  className: PropTypes.string,
};

export default Notificatio;
